import { SecurityBadge } from "@circle-react/components/shared/Paywalls/components/SecurityBadge";
import { Link } from "@circleco/compass/components/Link";

import { t } from "@/i18n-js/instance";

const LOCALE_ROOT =
  "paywall_checkout.form.email_verification_states.password_state";

interface FooterSectionProps {
  isSubmitting: boolean;
  isSubmittingForgotPassword: boolean;
  onForgotPasswordSubmit?: () => void;
  onShowOTPForm: () => void;
}

export const FooterSection = ({
  isSubmitting,
  isSubmittingForgotPassword,
  onForgotPasswordSubmit,
  onShowOTPForm,
}: FooterSectionProps) => (
  <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
    <div className="flex justify-between sm:gap-4">
      <Link
        asButton
        variant="custom"
        typography="label-sm"
        hoverDecoration="underline"
        onClick={onForgotPasswordSubmit}
        disabled={isSubmitting || isSubmittingForgotPassword}
      >
        {t([LOCALE_ROOT, "forgot_password.link"])}
      </Link>

      <Link
        asButton
        variant="custom"
        typography="label-sm"
        hoverDecoration="underline"
        onClick={onShowOTPForm}
        disabled={isSubmitting || isSubmittingForgotPassword}
      >
        {t([LOCALE_ROOT, "sign_in_with_code"])}
      </Link>
    </div>

    <div className="flex justify-start sm:justify-end">
      <SecurityBadge />
    </div>
  </div>
);
